import { z } from 'zod';

// https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#basiccreatedresponse
//
// {
//     "messages": [ String ]
//     "id": String
// }

export const schemaEuropaceBasicCreatedResponse = z.object({
    id: z.string(),
    messages: z.array(z.optional(z.string())),
});

export type SchemaEuropaceBasicCreatedResponse = z.infer<typeof schemaEuropaceBasicCreatedResponse>;
